import React from "react";
import "./ContactBanner.css";

const ContactBanner = () => {
  return (
    <div className="contact-banner-container">
      <p className="contact-banner-heading">
        <strong>An Experience, Not Just a Visit</strong>
      </p>
      <p className="contact-banner-text">
        Where coffee, florals, and atmosphere come together.
      </p>
    </div>
  );
};

export default ContactBanner;

{
  /* <a
  href="https://www.instagram.com/fleureuk/?igsh=cjNvbXM2ZGs5cWJ3#"
  target="_blank"
  rel="noopener noreferrer"
  className="contact-banner-link"
>
  Instagram
</a>{" "} */
}
